/*
 * Service worker registration (CRA-style, hand-rolled for CRA 5).
 *
 * Registers /service-worker.js ONLY in a production build served over
 * HTTPS or localhost. In `npm start` (development) it does nothing, so local
 * dev is never affected by caching.
 *
 * The SW uses skipWaiting + clients.claim, so a new version takes control
 * promptly; combined with network-first navigations, members are not stranded
 * on a stale bundle. (No forced reload here — avoids reload loops.)
 */
const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return; // dev build or unsupported browser -> no SW
  }

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        registration.onupdatefound = () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.onstatechange = () => {
            if (installing.state === 'installed') {
              if (navigator.serviceWorker.controller) {
                // Updated content is available; it will be used on next navigation.
                console.log('[SW] New content available — refresh to update.');
              } else {
                console.log('[SW] Content cached for offline use.');
              }
            }
          };
        };
      })
      .catch((err) => {
        console.error('[SW] registration failed:', err);
      });

    if (isLocalhost) {
      // Helpful log so you can see it active when serving the build locally.
      navigator.serviceWorker.ready.then(() => {
        console.log('[SW] active (localhost). Verify in DevTools → Application → Service Workers.');
      });
    }
  });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => registration.unregister())
      .catch((err) => console.error(err));
  }
}
